/* eslint-disable */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const TextArea = ((props, ref) => {
  const { label, placeholder, required, readOnly, type, name, error, defaultValue, onChange, maxLength, action, tooltiptext } = props; 
  const [tooltipFlag, setShowTooltip] = useState(false)

  return (
    <div style={{ position: 'relative' }}>
      {error?true:false}
      <se-form-field
        label={label}
        option='inline'
        block
        label-align='left'
        required={required}
        data-testid='textfield'
        disabled={readOnly}
        status={error?"error":""}
        style={{ marginLeft: 0 }}
      >
      {action? <span className='labelIcon' onMouseEnter={() => setShowTooltip(true)} onMouseLeave= {() => setShowTooltip(false)}><se-tooltip position='top' color='information'><se-icon slot='trigger' option='raised'>{action}</se-icon>
      {tooltipFlag && (<div>{tooltiptext}</div>)}
      </se-tooltip></span> : null}
        <div style={{ display: 'flex',alignItems: 'center', flexDirection: 'column' }}>
          <textarea
            placeholder={ placeholder}
            name={name}
            maxLength={maxLength}
            data-testid='input'
            className={type == 'number'? 'removeSpin' : null}
            value={defaultValue}
            onChange={(e)=> onChange(e.target.value, name)}
          />
          {defaultValue && <div style={{fontSize: '9px', position: 'relative', fontStyle: 'italic', color: 'green'}}>Characters Left: {maxLength - defaultValue.length}</div>}
        </div>
      </se-form-field>
      {error && (<span className='errorMsg'>{error}</span>)}
    </div>
  );
});

export default TextArea;

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  handleClickShowPassword: PropTypes.func,
  handleInputChange: PropTypes.func,
  required: PropTypes.bool.isRequired,
  error: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  handleEvent: PropTypes.func,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func
};

TextArea.defaultProps = {
  defaultValue: null,
};
